import { render, staticRenderFns } from "./ZoneLocationAreas.vue?vue&type=template&id=2674cc6e&scoped=true"
import script from "./ZoneLocationAreas.vue?vue&type=script&lang=js"
export * from "./ZoneLocationAreas.vue?vue&type=script&lang=js"
import style0 from "./ZoneLocationAreas.vue?vue&type=style&index=0&id=2674cc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674cc6e",
  null
  
)

export default component.exports